import { apiFetch } from './http';

/**
 * A scripted night's phase backbone (engine step E12), as the platform reads it
 * from its copy of the runtime's script events against the definition
 * (`SessionPhases`): every phase, live, for whoever directs the night
 * (`DIRECTION`); the phases that fired, in order, once the night is over, for
 * anybody else (`REPORT`); nothing before that (`NONE`).
 */
export interface ScriptPhase {
  id: string;
  /** The script's own Catalan title, or the id when it has none. */
  title: string;
  fired: boolean;
  /** Mission seconds of its first firing; null when it has not fired. */
  at: number | null;
  count: number;
  /** What fired it (the script's label for the branch); the direction's only. */
  firedBy: string | null;
  /** The alarm state it fired in; the direction's only. */
  alarm: string | null;
}

/** One of the night's other script events, for the direction: a mechanic's, a clock mark, an order. */
export interface ScriptMark {
  name: string;
  at: number;
  count: number;
  alarm: string;
  data: Record<string, unknown>;
}

export interface SessionPhasesView {
  audience: 'DIRECTION' | 'REPORT' | 'NONE';
  scripted: boolean;
  phases: ScriptPhase[];
  /** The phase that fired last. */
  current: string | null;
  events: ScriptMark[];
}

export const fetchSessionPhases = (code: string) =>
  apiFetch<SessionPhasesView>(`/api/sessions/${code}/phases`);
